import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";

function ___$insertStyle(css) {
  if (!css) {
    return;
  }

  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

import React, { createElement, useRef as useRef$2, useState as useState$1 } from 'react';

___$insertStyle(".marquee-container {\n  overflow: hidden;\n  position: relative;\n}\n.marquee-container .marquee {\n  position: absolute;\n}\n.marquee-container::before, .marquee-container::after {\n  content: \" \";\n  position: absolute;\n  z-index: 1;\n}\n.marquee-container:not(.horizontal)::before, .marquee-container:not(.horizontal)::after {\n  height: 10%;\n  width: 100%;\n}\n.marquee-container:not(.horizontal)::before {\n  background: white;\n  background: linear-gradient(180deg, white 0%, rgba(255, 255, 255, 0.6) 80%, rgba(255, 255, 255, 0) 100%);\n  top: 0;\n}\n.marquee-container:not(.horizontal)::after {\n  background: white;\n  background: linear-gradient(360deg, white 0%, rgba(255, 255, 255, 0.6) 80%, rgba(255, 255, 255, 0) 100%);\n  bottom: 0;\n}\n.marquee-container.horizontal::before, .marquee-container.horizontal::after {\n  height: 100%;\n  width: 5%;\n}\n.marquee-container.horizontal::before {\n  background: white;\n  background: linear-gradient(90deg, white 0%, rgba(255, 255, 255, 0.6) 80%, rgba(255, 255, 255, 0) 100%);\n  left: 0;\n}\n.marquee-container.horizontal::after {\n  background: white;\n  background: linear-gradient(270deg, white 0%, rgba(255, 255, 255, 0.6) 80%, rgba(255, 255, 255, 0) 100%);\n  right: 0;\n}\n.marquee-container.horizontal .marquee {\n  align-items: center;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  white-space: nowrap;\n}");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var useEffect = React.useEffect,
    useRef = React.useRef;

function useInterval(callback, delay) {
  var savedCallback = useRef({
    callback: function callback() {
      return undefined;
    }
  }); // Remember the latest callback.

  useEffect(function () {
    savedCallback.current.callback = callback;
  }, [callback]); // Set up the interval.

  useEffect(function () {
    function tick() {
      savedCallback.current.callback();
    }

    if (delay !== null) {
      var id = setInterval(tick, delay);
      return function () {
        return clearInterval(id);
      };
    }

    return undefined;
  }, [delay]);
}

var useRef$1 = useRef$2,
    useState = useState$1;
var marqueeDefaults = {
  delay: 40,
  direction: 'up',
  marqueeItems: [],
  minHeight: 150
};

var initState = function initState(props) {
  var marqueeItems = props.marqueeItems || marqueeDefaults.marqueeItems;
  return {
    bottom: 0,
    left: 0,
    marqueeItems: props.inverseMarqueeItems ? marqueeItems.reverse() : marqueeItems,
    right: 0,
    top: 0
  };
};

function Marquee(props) {
  var marqueeContainerRef = useRef$1(null);
  var marqueeRef = useRef$1(null);

  var _useState = useState(initState(props)),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var bottom = state.bottom,
      marqueeItems = state.marqueeItems,
      top = state.top,
      left = state.left,
      right = state.right;
  var height = props.height,
      marqueeClassName = props.marqueeClassName,
      marqueeContainerClassName = props.marqueeContainerClassName,
      marqueeItemClassName = props.marqueeItemClassName,
      minHeight = props.minHeight;
  var delay = props.delay || marqueeDefaults.delay;
  var direction = props.direction || marqueeDefaults.direction;
  var isHorizontal = direction === 'left' || direction === 'right';
  var marqueeContainerStyle = {};

  if (height) {
    marqueeContainerStyle.height = "".concat(height, "px");
  } else if (minHeight) {
    marqueeContainerStyle.minHeight = "".concat(minHeight, "px");
  } else {
    marqueeContainerStyle.minHeight = "".concat(marqueeDefaults.minHeight, "px");
  }

  var marqueeStyle = {};

  if (direction === 'up') {
    marqueeStyle.top = "".concat(top, "px");
  } else if (direction === 'right') {
    marqueeStyle.right = "".concat(right, "px");
  } else if (direction === 'down') {
    marqueeStyle.bottom = "".concat(bottom, "px");
  } else if (direction === 'left') {
    marqueeStyle.left = "".concat(left, "px");
  }

  var getFirstMarqueeItemSize = function getFirstMarqueeItemSize() {
    var _marqueeRef$current;

    var childNode = (_marqueeRef$current = marqueeRef.current) === null || _marqueeRef$current === void 0 ? void 0 : _marqueeRef$current.firstChild;

    if (childNode instanceof HTMLDivElement) {
      if (isHorizontal) {
        return childNode.offsetWidth;
      }

      return childNode.offsetHeight;
    }

    return 0;
  };

  var getLastMarqueeItemSize = function getLastMarqueeItemSize() {
    var _marqueeRef$current2;

    var childNode = (_marqueeRef$current2 = marqueeRef.current) === null || _marqueeRef$current2 === void 0 ? void 0 : _marqueeRef$current2.lastChild;

    if (childNode instanceof HTMLDivElement) {
      if (isHorizontal) {
        return childNode.offsetWidth;
      }

      return childNode.offsetHeight;
    }

    return 0;
  };

  useInterval(function () {
    var nextMarqueeItems = _toConsumableArray(marqueeItems);

    var nextProp;

    switch (direction) {
      case 'up':
        nextProp = 'top';
        break;

      case 'right':
        nextProp = 'right';
        break;

      case 'down':
        nextProp = 'bottom';
        break;

      case 'left':
        nextProp = 'left';
        break;

      default:
        nextProp = 'top';
        break;
    }

    var nextPropValue = state[nextProp]; // Next tic value

    nextPropValue -= 1;
    var marqueeItemSize = direction === 'up' || direction === 'left' ? getFirstMarqueeItemSize() : getLastMarqueeItemSize();
    var marqueeItemPassed = (marqueeItemSize ? Math.floor(Math.abs(nextPropValue) / marqueeItemSize) : 0) > 0;

    if (marqueeItemPassed) {
      if (direction === 'up' || direction === 'left') {
        nextMarqueeItems.push(nextMarqueeItems.shift());
      } else {
        nextMarqueeItems.unshift(nextMarqueeItems.pop());
      }

      nextPropValue = nextPropValue + marqueeItemSize;
    }

    setState(function (s) {
      var _objectSpread2$1;

      return _objectSpread2(_objectSpread2({}, s), {}, (_objectSpread2$1 = {}, _defineProperty(_objectSpread2$1, nextProp, nextPropValue), _defineProperty(_objectSpread2$1, "marqueeItems", nextMarqueeItems), _objectSpread2$1));
    });
  }, delay);
  var marqueeItemElms = marqueeItems.map(function (marqueeItem, i) {
    return /*#__PURE__*/createElement("div", {
      className: "marquee-item".concat(marqueeItemClassName ? " ".concat(marqueeItemClassName) : ''),
      key: i
    }, marqueeItem);
  });
  return /*#__PURE__*/createElement("div", {
    className: "marquee-container".concat(isHorizontal ? ' horizontal' : '').concat(marqueeContainerClassName ? " ".concat(marqueeContainerClassName) : ''),
    ref: marqueeContainerRef,
    style: marqueeContainerStyle
  }, /*#__PURE__*/createElement("div", {
    className: "marquee".concat(marqueeClassName ? " ".concat(marqueeClassName) : ''),
    ref: marqueeRef,
    style: marqueeStyle
  }, marqueeItemElms));
}

export default Marquee;